export default "__VITE_ASSET__DJGgm4Bn__"